var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',_vm._b({staticClass:"p-file-icon",attrs:{"color":_vm.iconMapping.color}},'v-icon',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.iconMapping.icon)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }